// extracted by mini-css-extract-plugin
export default {"smart-people-group":"SmartPeopleGroup_smart-people-group__b+7Jt"};